import { render } from "./App.vue?vue&type=template&id=55199570"
const script = {}

import "./App.vue?vue&type=style&index=0&id=55199570&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_385237cdc31ad6fed45be0dc27322b77/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__